import { render, staticRenderFns } from "./comp_BookEditorCustomizationInputs-fromName-toName-lang-inscription.vue?vue&type=template&id=6295727c&"
import script from "./comp_BookEditorCustomizationInputs-fromName-toName-lang-inscription.vue?vue&type=script&lang=js&"
export * from "./comp_BookEditorCustomizationInputs-fromName-toName-lang-inscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports